import { AbstractControl, ValidatorFn } from '@angular/forms';

export function surveyOpenAtValidator(offset: number = 0): ValidatorFn {
  return (control: AbstractControl): { [key: string]: { to: number } } => {
    const servertimestamp = Date.now() + offset;
    if (typeof control.value === 'number' && control.value > servertimestamp) {
      return {
        open_at: { to: control.value - servertimestamp }
      };
    }
    return null;
  };
}
